import { getAuthenticatedApiClient } from '../api-client';
import { useMutation } from 'react-query';

const deleteSponsor = (id: number) =>
  getAuthenticatedApiClient()
    .deleteSponsor({ id })
    .then((res) => res.data);

export const useDeleteSponsor = () => useMutation('delete-sponsor', deleteSponsor);
